module.exports = __webpack_public_path__ + "assets/img/process-2.7a5d64e2.png";